import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ParkingSlotState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: ParkingSlotState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const parkingSlotSlice = createSlice({
  name: 'parkingSlot',
  initialState,
  reducers: {
    setParkingSlot: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewParkingSlot: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setParkingSlot, addNewParkingSlot, reset } = parkingSlotSlice.actions;
export const getParkingSlot = (state: any) => state.parkingSlot.data;

export default parkingSlotSlice.reducer;
